import CodeEditor from "../common/code-editor";
import React, { useState } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { useHistory } from "react-router-dom";
import { developerAccessTokenState } from "../global-state";
import Modal from "react-modal";

import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { schemaScriptState } from "../common/schema-state";
import { SAND_CAT } from "../config";
import { useToast } from "../common/toast";

function myCompletions(context) {
  let word = context.matchBefore(/\w*/);
  if (word.from == word.to && !context.explicit) {
    return null;
  }
  return {
    from: word.from,
    options: [
      { label: "match", type: "keyword" },
      { label: "hello", type: "variable", info: "(World)" },
      { label: "magic", type: "text", apply: "⠁⭒*.✩.*⭒⠁", detail: "macro" },
    ],
  };
}

const FinishEditDialog = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="Confirmation Dialog"
    >
      <p>The schema is not saved. Do you want to discard edits?</p>
      <button onClick={onConfirm}>Yes</button>
      <button onClick={onClose}>Cancel</button>
    </Modal>
  );
};

const SchemaEditView = () => {
  const [developerAccessToken, setDeveloperAccessToken] = useRecoilState(
    developerAccessTokenState,
  );
  const { successToast, warningToast, errorToast } = useToast();
  const [editable, setEditable] = useState(false);
  const [isEditFinishDialogOpen, setEditFinishDialogOpen] = useState(false);
  const history = useHistory();

  const handleEditFinishConfirm = () => {
    setEditable(false);
    setCode("# Enter your schema");
    setEditFinishDialogOpen(false);
  };

  const handleEditFinishCancel = () => {
    setEditFinishDialogOpen(false);
  };

  const [code, setCode] = useState(useRecoilValue(schemaScriptState));
  const [unsaved, setUnsaved] = useState(false);
  const [parseResults, setParseResults] = useState([]);

  const saveDraft = async () => {
    console.log(code);
    try {
      const response = await fetch(`${SAND_CAT}/schema/draft/save`, {
        method: "POST",
        headers: {
          DeveloperAuthorization: `Bearer ${developerAccessToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ schema: code }),
      }); // Replace with your API URL
      const jsonData = await response.json();
      if (!response.ok) {
        throw new Error(jsonData);
      }
      if (jsonData["saved"]) {
        setUnsaved(false);
        if (jsonData["parseResults"].length === 0) {
          successToast("Saved.");
        } else {
          warningToast("Saved. But schema contains warning/errors.");
        }
      } else {
        if (jsonData["outOfSync"]) {
          errorToast("Please sync the current Staging schema first. ");
        } else {
          errorToast("Error! Please check the schema.");
        }
      }
      setParseResults(jsonData["parseResults"]);
    } catch (error) {
      errorToast("Error!");
      console.error("Error saving draft:", error);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={2} direction="column">
        <Grid item xs={1}>
          <Grid container spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                startIcon={<ArrowBackIcon />}
                onClick={goBack}
              >
                Back
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                onClick={saveDraft}
                disabled={!unsaved}
              >
                Save Draft
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={11}>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <CodeEditor
                  value={code}
                  editable={true}
                  onChange={instance => {
                    const code = instance.getValue();
                    setCode(code);
                    setUnsaved(true);
                  }}
                  parseResults={parseResults}
                  height={"800px"}
                />
              </Grid>
              <Grid item xs={6}></Grid>
            </Grid>
          </Box>
        </Grid>

        <FinishEditDialog
          isOpen={isEditFinishDialogOpen}
          onConfirm={handleEditFinishConfirm}
          onClose={handleEditFinishCancel}
        />
      </Grid>
    </Box>
  );
};

export default SchemaEditView;
